import FormAction from './form_action';

export default class GridFormAction extends FormAction {
	_gridActionType;
	_conditionToShowActionButton;

	constructor(actionProps = {}) {
		super(actionProps);
	}

	get gridActionType() {
		return this._gridActionType;
	}

	set gridActionType(value) {
		this._gridActionType = value;
	}

	get conditionToShowActionButton() {
		return this._conditionToShowActionButton;
	}

	set conditionToShowActionButton(value) {
		this._conditionToShowActionButton = value;
	}
}
